import { z } from 'zod';
/**
 * A count of something.
 *
 * One definition because a dozen schemas repeat it, and a repeated shape is a
 * repeated decision: the moment one of them allows a negative, a screen renders
 * "-3 delivered" and the contract that was supposed to prevent it agreed.
 *
 * Integer and non-negative, both deliberate. Postgres `count(*)` cannot be
 * either fractional or negative, so anything else arriving here means the two
 * halves have drifted rather than that a real figure went unusual.
 */
export const counter = z.number().int().min(0);
//# sourceMappingURL=counts.js.map